<div class="dashboard-body" *ngIf="dashboard == 'Tickets dashboard'">
  <div class="dashboard-caption">
      <div class="dashboard-caption-header">
        <div class="dashboard-header">
          <div class="title">
            <h4>Tickets dashboard</h4>
          </div>
          <div class="header-over-view dashboard1">
          </div>
          
          <div class="header-actions">
            <!-- <div class="select-day">
              <p>Last 7 days</p>
            </div> -->
            <div class="action-block">
              <i (click)="dashboardChange('Asset cost dashboard')" class="bi bi-arrow-left-circle"></i>
              <i (click)="dashboardChange('Asset distribution dashboard')" class="bi bi-arrow-right-circle"></i>
            </div>
          </div>
        </div>          
      </div>
      
      <div class="dashboard-content">
        <!-- <div class="chart-bar">
          <p-chart type="bar" height="350px" [data]="ticketsByStatusBarData" [options]="options"></p-chart>
        </div> -->
        

        <div class="bar-chats">
          <div class="bar-1">
            <p-chart type="bar" height="350px" [data]="ticketsByStatusBarData" [options]="barOptions"></p-chart>
          </div>
          <div class="bar-1">
            <p-chart type="bar" height="350px" [data]="ticketsByExpectedStartMonthBarData" [options]="barOptions"></p-chart>
          </div>
          <div class="bar-1">
            <p-chart type="bar" height="350px" [data]="ticketsByExpectedClosingMonthBarData" [options]="barOptions"></p-chart>
          </div>
        </div>
          
      </div>
      
  </div>
</div>


<div class="dashboard-body" *ngIf="dashboard == 'Asset cost dashboard'">
  <div class="dashboard-caption">
      <div class="dashboard-caption-header">
        <div class="dashboard-header">
          <div class="title">
            <h4>Asset cost dashboard</h4>
          </div>
          <div class="header-over-view dashboard1">
          </div>
          
          <div class="header-actions">
            <!-- <div class="select-day">
              <p>Last 7 days</p>
            </div> -->
            <div class="action-block">
              <i (click)="dashboardChange('Asset distribution dashboard')" class="bi bi-arrow-left-circle"></i>
              <i (click)="dashboardChange('Tickets dashboard')" class="bi bi-arrow-right-circle"></i>
            </div>
          </div>
        </div>          
      </div>
      
      <div class="dashboard-content">
        <!-- <div class="chart-bar">
          <p-chart type="bar" height="350px" [data]="ticketsByStatusBarData" [options]="options"></p-chart>
        </div> -->
        

        <div class="bar-chats">
          <div class="bar-1">
            <p-chart type="pie" height="350px" [data]="assetsOriginalCostByBranchPieData" [options]="options"></p-chart>
          </div>
          <div class="bar-1">
            <p-chart type="pie" height="350px" [data]="assetsCurrentCostByBranchPieData" [options]="options"></p-chart>
          </div>
          <div class="bar-1">
            <p-chart type="bar" height="350px" [data]="assetsCostByTypeBarData" [options]="barOptions"></p-chart>
          </div>
        </div>
          
      </div>
      
  </div>
</div>


<div class="dashboard-body" *ngIf="dashboard == 'Asset distribution dashboard'">
  <div class="dashboard-caption">
      <div class="dashboard-caption-header">
        <div class="dashboard-header">
          <div class="title">
            <h4>Asset distribution dashboard</h4>
          </div>
          <div class="header-over-view dashboard1">
          </div>
          
          <div class="header-actions">
            <!-- <div class="select-day">
              <p>Last 7 days</p>
            </div> -->
            <div class="action-block">
              <i (click)="dashboardChange('Tickets dashboard')" [ngClass]="{'active_dashboard': dashboard1}" class="bi bi-arrow-left-circle"></i>
              <i (click)="dashboardChange('Asset cost dashboard')" [ngClass]="{'active_dashboard': dashboard2}" class="bi bi-arrow-right-circle"></i>
            </div>
          </div>
        </div>          
      </div>
      
      <div class="dashboard-content">
        <!-- <div class="chart-bar">
          <p-chart type="bar" height="350px" [data]="ticketsByStatusBarData" [options]="options"></p-chart>
        </div> -->
        

        <div class="bar-chats">
          <div class="bar-1">
            <p-chart type="pie" height="350px" [data]="assetsByTypePieData" [options]="options"></p-chart>
          </div>
          <div class="bar-1">
            <p-chart type="bar" height="350px" [data]="assetsAcrossYearsBarData" [options]="barOptions"></p-chart>
          </div>
          <div class="bar-1">
            <p-chart type="bar" height="350px" [data]="assetsByTemplateBarData" [options]="barOptions"></p-chart>
          </div>
        </div>
          
      </div>
      
  </div>
</div>